import { render, staticRenderFns } from "./matchmacking.vue?vue&type=template&id=6776fa94&"
import script from "./matchmacking.vue?vue&type=script&lang=js&"
export * from "./matchmacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports